"use client";

import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import styled from "styled-components";

import { CautionCircle } from "./CautionCircle";

interface IPropTypes {
  message: string;
}

const Paragraph = styled(Typography).attrs({
  color: "#ff6d6d",
})`
  &&& {
    line-height: 20px;
  }
`;

export const ErrorMessage: React.FunctionComponent<IPropTypes> = (props) => (
  <Row align="center">
    <Paragraph>{props.message}</Paragraph>
    <CautionCircle />
  </Row>
);
